import { ConsumerCategory } from '~types/appsync.types';

export const getMinMaxAges = (
  consumerCategories?: ConsumerCategory[],
): { min: number; max: number } | undefined => {
  if (!consumerCategories || consumerCategories.length === 0) {
    return undefined;
  }

  const allAges = consumerCategories.reduce((ages: number[], consumerCategory) => {
    ages.push(consumerCategory.ageMin, consumerCategory.ageMax);
    return ages;
  }, []);

  return {
    max: Math.max(...allAges),
    min: Math.min(...allAges),
  };
};
